import React, {
    useState,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle
} from 'react';
import {
    Button,
    Typography,
    Box
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { IconButton, Tooltip } from "@mui/material";
import { headers, loginMemberId } from "../../../utils/utils";

const WorkTimer = forwardRef(({ workTime, ticketNumber, ticketItemId = null, userId = loginMemberId() }, ref) => {
    const [isWorking, setIsWorking] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [startTime, setStartTime] = useState(null);

    const timerRef = useRef(null);
    const updateRef = useRef(null);
    const timeSessionIdRef = useRef('');

    function formatTime(totalSeconds) {
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    const sendWorkSessionToServer = (start, end, seconds) => {
        const savedSession = localStorage.getItem('workSession');
        if (savedSession) {
            const sessionData = JSON.parse(savedSession);
            if (sessionData.ticketNumber == ticketNumber) {
                const payload = {
                    ticket: ticketNumber ? { id: ticketNumber } : undefined,
                    ticketItem: ticketItemId ? { id: ticketItemId } : undefined,
                    userId: userId,
                    id: timeSessionIdRef.current,
                    startTime: start.toISOString(),
                    endTime: end ? end.toISOString() : null,
                    elapsedSeconds: seconds
                };

                fetch(`${process.env.REACT_APP_TICKET_SERVER}/ticket/ticketTimeUpdate/${ticketNumber}`, {
                    method: 'POST',
                    headers: headers(),
                    body: JSON.stringify(payload),
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.id) {
                            timeSessionIdRef.current = data.id;
                        }
                    })
                    .catch(err => {
                        console.error('Error saving work session:', err);
                    });
            } else {
                setIsWorking(false)
            }
        }
    };

    const stopWorkSession = () => {
        if (isWorking && startTime) {
            const endTime = new Date();
            const elapsed = Math.floor((endTime - new Date(startTime)) / 1000);
            sendWorkSessionToServer(startTime, endTime, elapsed);
            localStorage.removeItem('workSession');
            timeSessionIdRef.current = null;
            setIsWorking(false);
        }
    };

    useImperativeHandle(ref, () => ({
        stopWorkSession,
    }));

    const toggleWork = () => {
        if (!isWorking) {
            const now = new Date();
            setStartTime(now);
            localStorage.setItem('workSession', JSON.stringify({
                ticketNumber,
                startTime: now.toISOString()
            }));
            setIsWorking(prev => !prev);
            // Fire immediately instead of waiting for the first 5s heartbeat, so a session
            // (and its PMS-linked timer, if this ticket has one) shows up as started right away.
            sendWorkSessionToServer(now, null, 0);
        } else {
            console.log("S")
            stopWorkSession();
        }

        console.log("S")
    };

    // useEffect(() => {
    //     const savedSession = localStorage.getItem('workSession');
    //     if (savedSession) {
    //         const sessionData = JSON.parse(savedSession);

    //         setStartTime(new Date(sessionData.startTime));
    //         setIsWorking(true);
    //     }
    // }, []);
   useEffect(() => {
        setElapsedTime(workTime)
         }, [workTime]);
    useEffect(() => {
    
        if (isWorking) {
            timerRef.current = setInterval(() => {
                setElapsedTime(prev => prev + 1);
            }, 1000);

            updateRef.current = setInterval(() => {
                const endTime = new Date();
                const elapsed = Math.floor((endTime - new Date(startTime)) / 1000);
                sendWorkSessionToServer(startTime, endTime, elapsed);
            }, 5000);
        } else {
            clearInterval(timerRef.current);
            clearInterval(updateRef.current);
        }

        return () => {
            clearInterval(timerRef.current);
            clearInterval(updateRef.current);
        };
    }, [isWorking, startTime]);

    return (
        <>
            {ticketNumber ?
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap",
                        mt: 2,
                    }}
                >



                    {/* Timer Chip */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,

                            borderRadius: "50px", // pill shape like a chip
                            padding: "8px 16px",
                            backgroundColor: "#F5F5F5",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                    >
                        <IconButton
                            onClick={toggleWork}
                            sx={{
                                backgroundColor: isWorking ? "#d32f2f" : "#2e7d32",
                                color: "#fff",
                                fontSize: 12,
                                width: 30,
                                height: 30,
                                borderRadius: "50%",
                                "&:hover": {
                                    backgroundColor: isWorking ? "#b71c1c" : "#1b5e20",
                                },
                            }}
                        >
                             {isWorking ? <StopIcon /> : <PlayArrowIcon />}
                        </IconButton>
                        <Typography
                            variant="body1"
                            sx={{

                                fontSize: 16,
                                letterSpacing: "3px",
                                color: "black",
                            }}
                        >
                            {formatTime(elapsedTime)}
                        </Typography>
                    </Box>

                    {/* Round Start/Stop Button */}

                </Box>

                : <></>}
        </>
    );
});

export default WorkTimer;
